<template>
    <div
        ref="json-field"
    ></div>
</template>

<script>

import JsonEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.min.css';
export default {

    components: {

    },

    props: {
        json: {
            type: Object,
            required: true,
        },
    },

    data (){
        return {
            editor: null,
        };
    },

    computed: {

    },

    mounted (){
        let editor = new JsonEditor(
            this.$refs['json-field'],
            {
                onChangeText: this.jsonEdited,
                mode: 'text',
            }
        );
        this.$set(this, 'editor', editor);
        this.editor.set(this.json);
    },

    methods: {
        jsonEdited (json){
            this.$emit('json-updated', json);
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/nsPaginate/json-editor.vue